import React, { useEffect, useState } from "react";
import {
    Pressable, Text, View, Image, ScrollView, TextInput
} from "react-native";
import { store } from "../../store/store";

import { ScreenPushBackData } from "../../utils/services/subject-behaviour/CommonRxjsService";

import { PrimaryCTA } from "../../utils/widgets/CommonCTA";
import { IconView } from "../../utils/widgets/CommonWidget/Icons";
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";

import { LocationName } from "../../utils/constants/ConstantsMapping";
import { ScreenPushBackCode } from "../../utils/constants/SubjectBehaviousConstant";
import { NavigateFrom, ScreenRoute } from "../../utils/constants/ScreenRouteConstant";

import AppTheme from "../../AppTheme";
import AppStyles from "../../AppStyles";
import TextStyle from "../../TextStyle";
import Colors from "../../utils/constants/AppColors";

import * as OMSAPI from '../../utils/services/api/OMSAPI'
import * as Rxjs from "../../utils/services/subject-behaviour/CommonRxjsService";
import * as AlertService from "../../utils/services/AlertLoaderService";
import { AddressInfoView, LocationIconView } from "../../utils/widgets/Location/Location-Widget";
import { MoengageEvents, trackMoengageEvents } from "../../utils/services/webapp-services/MoengageUtils";

const UpsertUserAddress = (props) => {

    const reduxState = store.getState();

    const isUserLoggedIn = reduxState.isUserLogin
    const userDetails = reduxState.userDetails;

    const selectedLocation = props?.route?.params?.selectedLocation ?? {}
    const isEditAddress = props?.route?.params?.isEditAddress ?? false
    const isNavigateFromReviewOrder = props?.route?.params?.fromReviewOrder ?? false

    const addressId = selectedLocation['aid'] ?? ''

    const [locationName, updateLocationName] =
        useState(selectedLocation['name'] ?? '')

    const [locationBannerTitle, updateLocationTitle] = useState(
        selectedLocation['locationTitle'] ? selectedLocation['locationTitle'] :
            'Let the store know where to deliver order')

    const [flatAndBuilding, updateFlatBuilding] =
        useState(selectedLocation['flat_and_building'] ?? '')
    const [locality, updateLocality] =
        useState(selectedLocation['locality'] ?? '')
    const [address, updateAddress] =
        useState(selectedLocation['address'] ?? '')

    const [placeId, updatePid] =
        useState(selectedLocation['pid'] ?? '')

    const [coordinates, updateCoordinates] =
        useState(selectedLocation['coordinates'] ?? {})

    const [inputLocationName, updateInputAddressName] =
        useState(selectedLocation['inputLocationName'] ?? '')
    const [inputUserName, updateInputUserName] =
        useState(selectedLocation['inputUserName'] ?? '')

    const [isLocationValidForPharmacy, updateLocationValidity] = useState(true)

    useEffect(() => {
        ScreenPushBackData.getPushBackData().subscribe((data) => {
            if (data['pushBackCode'] == ScreenPushBackCode[NavigateFrom.save_location_for_search_locality]) {
                let fetchLocationData = data['pushBackData']
                updatePid(fetchLocationData['pid'])
                updateAddress(fetchLocationData['address'])
                updateCoordinates(fetchLocationData['coordinates'])
                updateLocationTitle(fetchLocationData['locationTitle'])
                if (isNavigateFromReviewOrder) {
                    const reduxState: any = store.getState();
                    const selectedStore = reduxState.pharmacyAllData
                    checkLocationValidForPharmcy(selectedStore['id'],
                        fetchLocationData['coordinates'], fetchLocationData['pid'])
                }
                ScreenPushBackData.clearPushBackData()
            }
        })
    }, [])

    const navigateToSearchLocality = () => {
        global.navigateFrom = NavigateFrom.save_location_for_search_locality
        props.navigation.navigate(ScreenRoute.search_locality)
    }

    const checkLocationValidForPharmcy = (pharmacyId, location, placeId) => {
        const params = { pharmacyId: pharmacyId, location: location, placeId: placeId }

        if (isUserLoggedIn) {
            OMSAPI.doPost('user/address/check_location_serviceability', params).then(
                (response: any) => {
                    if (response)
                        updateLocationValidity(response.serviceable ? true : false)
                }, (err: any) => { console.log("API is failed with error " + err) })
        } else {
            OMSAPI.doPostGuest('check_location_serviceability', params).then(
                (response: any) => {
                    if (response)
                        updateLocationValidity(response.serviceable ? true : false)
                }, (err: any) => { console.log("API is failed with error " + err) })
        }
    }

    const checkDataValidity = () => {
        return flatAndBuilding && locality && locationName &&
            (locationName != 'Other' || inputLocationName) &&
            address && isLocationValidForPharmacy &&
            (!(isNavigateFromReviewOrder)
                || (userDetails['isNameCaptured'] || inputUserName))
    }


    async function onSubmit() {
        const addressData = {
            name: locationName == 'Other' ? inputLocationName : locationName,
            address: address,
            flat_and_building: flatAndBuilding,
            locality: locality,
            aid: addressId,
            pid: placeId,
        }
        if (coordinates && coordinates['latitude'] && coordinates['longitude'])
            addressData['location'] = coordinates['latitude'] + ',' + coordinates['longitude']
        else addressData['location'] = ''

        let userUpdatedData = {}
        if (inputUserName) userUpdatedData['name'] = inputUserName

        if (isUserLoggedIn) {
            AlertService.loaderModal.setLoader(true)
            let pushBackCode = ScreenPushBackCode.savedLocationForAddList
            if (isNavigateFromReviewOrder)
                pushBackCode = ScreenPushBackCode.savedLocationForCart
            if (isEditAddress) {
                addressData['aid'] = addressId
                OMSAPI.doPost('user/address/update', addressData).then(
                    (response: any) => {
                        Rxjs.ScreenPushBackData.setData({
                            pushBackCode: pushBackCode,
                            pushBackData: response
                        })
                        props.navigation.goBack();
                        AlertService.loaderModal.setLoader(false);
                    }, (err: any) => {
                        console.log("API is failed with error " + err);
                        AlertService.loaderModal.setLoader(false);
                    }
                )
            } else {
                OMSAPI.doPost('user/address/add', addressData).then(
                    (response: any) => {
                        Rxjs.ScreenPushBackData.setData({
                            pushBackCode: pushBackCode,
                            pushBackData: {
                                ...response,
                                userUpdatedData: userUpdatedData
                            }
                        })
                        trackMoengageEvents(MoengageEvents.new_address_added)
                        global.appHandledBackpress = true
                        props.navigation.goBack();
                        AlertService.loaderModal.setLoader(false);
                    }, (err: any) => {
                        console.log("API is failed with error " + err);
                        AlertService.loaderModal.setLoader(false);
                    }
                )
            }
        } else if (isNavigateFromReviewOrder) {
            let orderData = {}
            Rxjs.OMSOrderDataSubscription.getomsOrderData().
                subscribe((orderDataSubscription: any) => {
                    orderData = orderDataSubscription.orderData;
                }).unsubscribe()
            Rxjs.OMSOrderDataSubscription.setomsOrderData({
                orderData: orderData, addressData: addressData,
                userUpdatedData: userUpdatedData
            })
            global.navigateFrom = NavigateFrom.add_address_for_create_order;
            props.navigation.navigate(ScreenRoute.login);
        }

    }

    return (
        <View style={[]}>

            <CommonHeader navigation={props.navigation}
                title={isEditAddress ? 'Edit Address' : 'Add New Address'} />

            <ScrollView style={[{
                marginTop: AppTheme.headerHeight,
                paddingBottom: locationName == 'Other' ?
                    AppTheme.bottomFixButton + 100 :
                    AppTheme.bottomFixButton + 16
            }]}>

                <Pressable onPress={() => { navigateToSearchLocality() }}
                    style={[AppStyles.flexRowSpaceBetween, {
                        paddingVertical: 16, paddingHorizontal: 16,
                        backgroundColor: Colors.blue.bg
                    }]}>
                    <AddressInfoView location={{
                        name: 'Other', address: address,
                        locality: locality, flat_and_building: flatAndBuilding
                    }} title={'Deliver To'} subTitle={locationBannerTitle}
                        titleColor={Colors.primary}
                        isActive={true} numberOfLines={1} />
                    <IconView icon={'edit_circle.svg'} size={32} />
                </Pressable>
                {!isLocationValidForPharmacy && <View style={{ marginHorizontal: 16, marginVertical: 4 }}>
                    <Text style={[TextStyle.text10, { color: Colors.red.highlight }]}>
                        This location is not servicable</Text>
                </View>}

                <View style={{ marginHorizontal: 16 }}>

                    {
                        isNavigateFromReviewOrder && !userDetails['isNameCaptured'] &&
                        <Text style={[TextStyle.text12, { marginTop: 24 }]}>
                            Full Name</Text>
                    }

                    {
                        isNavigateFromReviewOrder &&
                        !userDetails['isNameCaptured'] &&
                        <TextInput style={[AppStyles.borderView, AppStyles.bgWhite, TextStyle.text16,
                        {
                            color: Colors.grey.text, marginTop: 8,
                            paddingHorizontal: 16, paddingVertical: 16
                        }]}
                            onChangeText={(text) => { updateInputUserName(text) }}
                            placeholder="Full Name"
                            value={inputUserName} />
                    }

                    <Text style={[TextStyle.text12, { marginTop: 24 }]}>
                        House/Floor number</Text>

                    <TextInput style={[AppStyles.borderView, AppStyles.bgWhite, TextStyle.text16,
                    {
                        color: Colors.grey.text, marginTop: 8,
                        paddingHorizontal: 16, paddingVertical: 16
                    }]}
                        onChangeText={(text) => { updateFlatBuilding(text) }}
                        placeholder="E.g. 404/2B"
                        value={flatAndBuilding} />

                    <Text style={[TextStyle.text12, { marginTop: 24 }]}>
                        Street name/Landmark</Text>

                    <TextInput style={[AppStyles.borderView, AppStyles.bgWhite, TextStyle.text16,
                    {
                        color: Colors.grey.text, marginTop: 8,
                        paddingHorizontal: 16, paddingVertical: 16
                    }]}
                        onChangeText={(text) => { updateLocality(text) }}
                        placeholder="E.g. Opposite Delhi Public School"
                        value={locality} />

                    <Text style={[TextStyle.text16b, { marginVertical: 24 }]}>
                        Address type</Text>

                    <View style={[AppStyles.flexRowSpaceAround]}>

                        <View>
                            <Pressable style={[AppStyles.borderViewRound, { padding: 12 }]}
                                onPress={() => { updateLocationName(LocationName.home) }}>
                                {LocationIconView({
                                    locationName: LocationName.home,
                                    isActive: locationName == LocationName.home
                                })}
                            </Pressable>
                            <Text style={[TextStyle.text14b, { marginTop: 8 }]}>
                                {LocationName.home}</Text>
                        </View>

                        <View>
                            <Pressable style={[AppStyles.borderViewRound, { padding: 12 }]}
                                onPress={() => { updateLocationName(LocationName.work) }}>
                                {LocationIconView({
                                    locationName: LocationName.work,
                                    isActive: locationName == LocationName.work
                                })}
                            </Pressable>
                            <Text style={[TextStyle.text14b, { marginTop: 8 }]}>
                                {LocationName.work}</Text>
                        </View>

                        <View>
                            <Pressable style={[AppStyles.borderViewRound, { padding: 12 }]}
                                onPress={() => { updateLocationName(LocationName.other) }}>
                                {LocationIconView({
                                    locationName: LocationName.other,
                                    isActive: locationName == LocationName.other
                                })}
                            </Pressable>
                            <Text style={[TextStyle.text14b, { marginTop: 8 }]}>
                                {LocationName.other}</Text>
                        </View>

                    </View>

                    {
                        locationName == LocationName.other &&
                        <TextInput style={[AppStyles.borderView, AppStyles.bgWhite,
                        TextStyle.text16, {
                            color: Colors.grey.text, marginTop: 8,
                            paddingHorizontal: 16, paddingVertical: 16
                        }]} onChangeText={(text) => { updateInputAddressName(text) }}
                            placeholder="Like Dadi's House" value={inputLocationName} />
                    }

                </View>

            </ScrollView>

            <View style={[AppStyles.bottomFix, AppStyles.bgWhite,
            AppStyles.mediumShadow, { padding: 16 }]}>
                <PrimaryCTA text={'Save & Continue'}
                    disabled={!checkDataValidity()}
                    onPress={() => { onSubmit() }} />
            </View>

        </View>
    )
}

export default UpsertUserAddress
